function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99984 8.66665C8.36803 8.66665 8.6665 8.36817 8.6665 7.99998C8.6665 7.63179 8.36803 7.33331 7.99984 7.33331C7.63165 7.33331 7.33317 7.63179 7.33317 7.99998C7.33317 8.36817 7.63165 8.66665 7.99984 8.66665Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6665 8.66665C13.0347 8.66665 13.3332 8.36817 13.3332 7.99998C13.3332 7.63179 13.0347 7.33331 12.6665 7.33331C12.2983 7.33331 11.9998 7.63179 11.9998 7.99998C11.9998 8.36817 12.2983 8.66665 12.6665 8.66665Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.33317 8.66665C3.70136 8.66665 3.99984 8.36817 3.99984 7.99998C3.99984 7.63179 3.70136 7.33331 3.33317 7.33331C2.96498 7.33331 2.6665 7.63179 2.6665 7.99998C2.6665 8.36817 2.96498 8.66665 3.33317 8.66665Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgHorizontalEllipsis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalEllipsis);
export default __webpack_public_path__ + "static/media/horizontal-ellipsis.7f67f2e3.svg";
export { ForwardRef as ReactComponent };